import { AxiosInstance, AxiosResponse } from "axios";
import { Assisteur, Programme, ProgrammeApiFactory } from "./swagger";

export interface IApi {
  getAssisteur(codeProgramme: string): Promise<Assisteur>;
  getProgrammeByCode(codeProgramme: string): Promise<Programme>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const programmeApi = ProgrammeApiFactory({}, endpoint, axiosClient);

  const getAssisteur = (codeProgramme): Promise<Assisteur> =>
    new Promise((resolve, reject) => {
      programmeApi
        .getAssisteurByCodeProgramme(codeProgramme)
        .then((response: AxiosResponse<Assisteur>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  const getProgrammeByCode = (codeProgramme): Promise<Programme> =>
    new Promise((resolve, reject) => {
      programmeApi
        .getProgrammeByCode(codeProgramme)
        .then((response: AxiosResponse<Programme>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  return {
    getAssisteur,
    getProgrammeByCode,
  };
};

export default create;
